import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";
import axios from "axios";
import io from "socket.io-client";
import appStore from "../store/appStore";
import { getSessionId } from "./sessionSetup";
const { v4: uuidv4 } = require("uuid");
// const SERVER ="https://app.ulai.in";
const SERVER = `https://${process.env.REACT_APP_API_BASE_SOCKET}`;
// const SERVER = "https://app.ulai.in";
//const SERVER = "http://localhost:8050";

export var socket = null;

export const connectWithSocketIOServer = () => {
  socket = io(SERVER, {
    // path: "/agent-live-chat-socket/",
    // transports: ["websocket"],
    // reconnection: true,
  });
  socket.on("connect", () => {
    appStore.getState().setIsConnected(true);
    createOrConnectRoom();
    console.log("Bot Connected with Server");
  });
  socket.on("room-id", (data) => {
    // const { roomId } = data;;
    // console.log(roomId);
  });

  socket.on("room-update", (data) => {
    // const { connectedUsers } = data;
    // console.log(connectedUsers);
  });

  socket.on("conn-prepare", (data) => {
    // console.log("conn-prepare", data);
  });
  socket.on("conn-signal", (data) => {
    // console.log("conn-signal", data);
  });

  socket.on("conn-init", (data) => {
    // const { connUserSocketId } = data;
    // console.log("conn-init", connUserSocketId);
  });

  socket.on("user-disconnected", (data) => {
    // console.log("Data disconnect", data);
  });

  socket.on("message-recieved", (data) => {
    let newMessage = JSON.parse(data);
    // console.log("newMessage", newMessage);
    if (newMessage.identity === "BOT" || newMessage.identity === "AGENT") {
      appStore.getState().messageType(newMessage, false);
      appStore.getState().setSuggestions(newMessage.possibleUserResponses);
      appStore.getState().setShowSuggestions(true);
    }
  });
  socket.on("web_sdk_message_send", (data) => {
    let newMessage = JSON.parse(data);
    // console.log("newMessage", newMessage);
    if (newMessage.identity === "BOT" || newMessage.identity === "AGENT") {
      appStore.getState().messageType({ ...newMessage, message: "" }, false);
      appStore.getState().setSuggestions(newMessage.openAiResponse.nextQueries);
      appStore.getState().setShowSuggestions(true);
    }
  });


    socket.on("web_sdk_message_send_text", (data) => {
    let newMessage = JSON.parse(data);
    // console.log("message coming from=============>", newMessage);
    if (newMessage.identity === "BOT" || newMessage.identity === "AGENT") {
      appStore.getState().messageTypev2(newMessage, false);
      appStore.getState().setSuggestions(newMessage.openAiResponse.nextQueries);
      appStore.getState().setShowSuggestions(true);
    }
  });
  // messageTypev2
  socket.on("disconnect", function () {
    appStore.getState().setIsConnected(false);
    console.log("client socketio disconnect!");
  });

  socket.on("users-chat", (data) => {
    if (
      data.data &&
      Object.keys(data.data).length !== 0 &&
      data.data.constructor === Object
    ) {
      appStore.getState().existingMessage(data.data);
    }

    // appStore.getState().messageType(newMessage, currentTime);
  });
};
export const getRoomExists = async (roomId) => {
  // const url = "http://localhost:8081";
  const url = `https://${process.env.REACT_APP_API_BASE_CUSTDOMAIN}/agent-live-chat/`;
  // const url = "https://ulai.in/agent-live-chat/";
  const response = await axios.get(`${url}/api/room-exists/${roomId}`);
  return response.data;
};
export const checkLoginUserid = async (id, roomId) => {
  if (appStore.getState().botDetails.storeName == "Shopify") {
    socket.emit("user_connected_storeId_check_shopify", {
      orgId: id,
      roomId,
      unqiueBrowserId: await getCurrentBrowserFingerPrint(),
      storeId: window?.__st?.cid ? window?.__st?.cid : null,
    });
  }
};
export const createOrConnectRoom = async (identity) => {
  let roomId = getSessionId(localStorage.getItem("sessionUUID"));
  const id = document.getElementById("chatBot").getAttribute("data-value");
  socket.emit("user_connected_to_room", {
    orgId: id,
    roomId,
    chatWindow:true,
    unqiueBrowserId: await getCurrentBrowserFingerPrint(),
  });

  const data = {
    identity: "USER",
    defaultConnection: socket.id,
    roomId: roomId,
    organization_id: appStore.getState().botDetails.userId,
  };
  if (!data.organization_id) return;
  if (roomId == undefined || roomId == null || roomId == "null") {
    // data.roomId = uuidv4();
    // localStorage.setItem("connectionId", data.roomId);
    // checkLoginUserid(data.organization_id, data.roomId);
  } else {
    // const resp = await getRoomExists(roomId);
    // if (!resp.roomExists) {
    //   socket.emit("create-new-room", data);
    // }
    appStore.getState().setRoomId(data);
    // socket.emit("join-room", data);
    // checkLoginUserid(data.organization_id, data.roomId);
    return;
  }
  appStore.getState().setRoomId(data);
  // socket.emit("create-new-room", data);
};
export const joinSession = (roomId) => {
  const data = {
    identity: "AGENT",
    roomId: roomId,
  };
  socket.emit("join-room", data);
};
export const sendDataToConnectedUser = (data) => {
  appStore.getState().setShowTyping(true);
  // data.socket_id = socket.id;
  var parsedData = JSON.parse(data);
// console.log(parsedData,"===========> parddaee")
  const newData = JSON.stringify({
    ...parsedData,
    socket_id: socket.id,
  });
  // console.log(newData,"===========> newDaga")
  socket.emit("web_sdk_message", newData);
};

export const getUserChat = (data) => {
  const payload = JSON.stringify({
    session_id: data,
  });
  socket.emit("get-user-chat", payload);
};
export const sendKafkaEvent = (data) => {
  const payload = JSON.stringify(data);
  socket.emit("store-websdk-event", payload);
};
